/**
 * @description HomeMyRecommendationGeneralHealth State.
 * @exports
 * @interface HomeMyRecommendationGeneralHealthState
 */
export interface HomeMyRecommendationGeneralHealthState {
  data: Array<any>;
}

export const homeMyRecommendationGeneralHealthKey =
  'home-myrecommendation-generalhealth';
export const homeMyRecommendationGeneralHealthState: HomeMyRecommendationGeneralHealthState =
  {
    data: []
  };
